export interface TaskRecord {
  id: string;
  object_id?: string;
  external_id: string;
  // From meta_data fields
  subject?: string;
  description?: string;
  native_subject?: string;
  native_description?: string;
  status?: string;
  priority?: string;
  board_status: BoardStatus;
  owner_side?: string;
  due_date?: string;
  assigned_to?: string;
  evidence_text?: string;
  source_type?: string; // meetings, emails, etc.
  task_type?: string; // INTERNAL_ACTION_ITEM, CUSTOMER_ACTION_ITEM, SHARED_ACTION_ITEM
  source_external_id?: string;
  // From related objects
  account_name?: string;
  account_domain?: string;
  account_external_id?: string;
  // Account fields (from include)
  account_arr?: number;
  account_mrr?: number;
  account_subscription_status?: string;
  // Timestamps
  created_at?: string;
  updated_at?: string;
}

export type BoardStatus =
  | "investigating"
  | "on_us"
  | "on_them"
  | "on_hold"
  | "needs_first_response"
  | "closed";

export const BOARD_STATUS_ORDER: BoardStatus[] = [
  "investigating",
  "needs_first_response",
  "on_us",
  "on_them",
  "on_hold",
  "closed",
];

export const BOARD_STATUS_LABELS: Record<BoardStatus, string> = {
  investigating: "Investigating",
  needs_first_response: "Needs first response",
  on_us: "On us",
  on_them: "On them",
  on_hold: "On hold",
  closed: "Closed",
};

// Default board columns shown (Agency hides on_hold/closed by default)
export const DEFAULT_BOARD_COLUMNS: BoardStatus[] = [
  "investigating",
  "on_us",
  "on_them",
];

export const BOARD_COLUMN_NAMES = DEFAULT_BOARD_COLUMNS.map(
  (status) => BOARD_STATUS_LABELS[status],
);

export const ALL_BOARD_COLUMN_NAMES = BOARD_STATUS_ORDER.map(
  (status) => BOARD_STATUS_LABELS[status],
);

export const BOARD_COLUMN_COLORS: Record<string, string> = {
  Investigating: "hsl(38, 92%, 50%)",        // Orange like Agency
  "Needs first response": "hsl(0, 72%, 55%)", // Red
  "On us": "hsl(142, 71%, 45%)",             // Green
  "On them": "hsl(0, 0%, 70%)",              // Grey like Agency
  "On hold": "hsl(212, 72%, 55%)",           // Blue
  Closed: "hsl(0, 0%, 50%)",                 // Dark grey
};

export const PRIORITY_DOT_COLORS: Record<string, string> = {
  high: "hsl(0, 72%, 55%)",     // Red dot
  medium: "hsl(38, 92%, 50%)",  // Orange dot
  low: "hsl(212, 72%, 55%)",    // Blue dot
};

export type TaskDisplayMode = "list" | "board";

export type TaskPriorityFilter = "all" | "high" | "medium" | "low";
export type TaskBoardStatusFilter = "all" | BoardStatus;
export type TaskAccountFilter = string;
export type TaskAssigneeFilter = string;

export interface TaskBoardCounts {
  investigating: number;
  needs_first_response: number;
  on_us: number;
  on_them: number;
  on_hold: number;
  closed: number;
  total: number;
}

export interface TaskSettings {
  id: string;
  workspace_id: string;
  enabled: boolean;
  account_filters?: Record<string, any>;
  guidance?: string;
  auto_close_enabled: boolean;
  auto_close_stale_days?: number;
}
